module.exports = __webpack_public_path__ + "img/alert-circle.80b0da83.svg";